import { Link } from "react-router-dom";
import NewArrivals from "./NewArrivals";

function New(){
    return(
        <div>
          <NewArrivals/>
        </div>
    )
}
export default New;